<style>
  .theWorld{
    width:100%;
  }
    @media screen and (max-width:500px ) {
      .theWorld{
        margin-top:40px;
      }
    }
</style>

<template>
  <div class='theWorld'><iframe  width="100%" scrolling="no" height="720" src="https://guigui.admin.thinkerx.com/home.php/guigui_user/map" frameborder="0"></iframe></div>
</template>

<script>
  //dio!
	export default {
		components:{

		},
		props:[],
		data() {
			return {

			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {

		}
	}
</script>
